import { render } from "./DashAgro.vue?vue&type=template&id=6450bf03&scoped=true"
import script from "./DashAgro.vue?vue&type=script&lang=js"
export * from "./DashAgro.vue?vue&type=script&lang=js"

import "./DashAgro.vue?vue&type=style&index=0&id=6450bf03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6450bf03"]])

export default __exports__